interface SupportTicketData {
  name: string;
  email: string;
  phone: string;
  category: string;
  priority: string;
  subject: string;
  description: string;
}

interface EmailResponse {
  success: boolean;
  messageId?: string;
  message?: string;
  error?: string;
}

export const sendSupportTicket = async (ticketData: SupportTicketData): Promise<EmailResponse> => {
  try {
    // Call Next.js API route for SMTP email sending
    const response = await fetch('/api/send-support-ticket', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(ticketData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send support ticket via SMTP');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      return {
        success: false,
        error: error.message
      };
    }
    return {
      success: false,
      error: 'An unexpected error occurred while sending the support ticket via SMTP'
    };
  }
};